export default () => {
  return {
    getImageWithResolution(imagePath, resolution) {
      if (!imagePath || !resolution)
        return

      return imagePath.replace('images/200/', 'images/' + resolution + '/')
    }
  }
}